import { FilterConfig } from '.';

type AlgoliaResults = {
  hits: any[];
  hitsPerPage: number;
  nbHits: number;
};

enum AlgoliaResultType {
  Trail = 'trail',
  Track = 'track',
  Place = 'place',
  List = 'list',
  Area = 'area',
  Map = 'map',
  Filter = 'filter'
}

type AlgoliaSearchFunction = (changes: { [key: string]: FilterConfig }) => Promise<AlgoliaResults>;

export { AlgoliaResults, AlgoliaResultType, AlgoliaSearchFunction };
